<template> 
   
     <router-view></router-view>
   
</template> 
<script>
   
    export default {
        name:'system',
        data () {
            return {
             
            }
        },
       

        computed: {
          
            
        },
        methods: {
               
           
            
        },
      
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style>
    
</style>
     